import { useCallback, useEffect, useState } from "react";

import SweetAlert from "react-bootstrap-sweetalert";
import { connect, useDispatch } from "react-redux";
import {
  getNotifications,
  getNotification,
  deleteNotification,
} from "../../../../../action/masters/notificationActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  INotificationIndex,
  INotificationData,
  INotifications,
} from "../../../../../models/master/notification";
import { setNotifications } from "../../../../../store/slices/master/notificationSlice";
import NotificationCreate from "./notificationCreate";
import NotificationEdit from "./notificationEdit";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";
import FloatingLabelDropDown from "../../../../../common-components/floatingdropdown";
import { sortAlphabetically } from "../../../../../common-functions/commonFunctions";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";
import { getUserTypes } from "../../../../../action/common/commonActionCreator";
import { UserRole } from "../../../../../constants/RoleEnum";

const NotificationsIndex = (props: INotificationIndex) => {
  const {
    getNotifications,
    notifications,
    currentUser,
    getNotification,
    notification,
    deleteNotification,
    getUserTypes,
    userTypes,
    currentRole,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [selectedUserType, setSelectedUserType] = useState<number | null>(null);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getNotification(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const getAllNotifications = async (userType?: number) => {
    setIsLoading(true);
    try {
      await getNotifications(userType);
    } finally {
      setIsLoading(false);
    }
  };

  const onUserTypeChange = useCallback((e: any) => {
    if (e.target.name == "userType") setSelectedUserType(e.target.value);
    getAllNotifications(e.target.value);
  }, []);

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteNotification(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllNotifications(selectedUserType ?? undefined);
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  useEffect(() => {
    getAllNotifications();
    getUserTypes();
    return () => {
      dispatch(setNotifications([]));
    };
  }, [currentUser]);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Notifications</h2>
          <div className="side-filter">
            {currentRole === UserRole.SuperAdmin && (
              <div className="justify-content-left">
                <FloatingLabelDropDown
                  label=""
                  placeholder="-Select UserType-"
                  onChange={(e: any) => onUserTypeChange(e)}
                  isMandatory={false}
                  value={selectedUserType}
                  name="userType"
                  optionsList={sortAlphabetically(
                    userTypes?.filter((type) => type.id !== UserTypes.Freshman)
                  )}
                />
              </div>
            )}
            <a
              href="javascript:void(0)"
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#addnewbuttons"
              onClick={handleCreateOpen}
            >
              <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
              Add New
            </a>
          </div>
        </div>

        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : notifications?.notifications &&
            notifications?.notifications?.length > 0 ? (
            notifications?.notifications.map((notification: INotifications) => {
              return (
                <li
                  className="admin-card"
                  style={{
                    pointerEvents: !notification.isActive ? "none" : "auto",
                    opacity: !notification.isActive ? 0.5 : 1,
                  }}
                >
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(notification.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(notification.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <div className="btm">
                    <h3>{notification.notificationTypeName}</h3>
                    <div className="btm">
                      <a
                        href="javascript:void(0)"
                        data-bs-toggle="modal"
                        data-bs-target="#viewdetails"
                      >
                        <div className="img">
                          <img
                            src={
                              notification.image
                                ? baseURL + notification.image
                                : "/assets/images/icon/graduation.svg"
                            }
                            onError={(e) => {
                              e.currentTarget.src =
                                "/assets/images/icon/graduation.svg";
                            }}
                          />
                        </div>
                      </a>
                    </div>
                    <h2>{notification.title}</h2>
                    <p>{notification.notificationMessage?.slice(0, 30)}</p>
                  </div>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <NotificationCreate
          setShowCreate={handleCreateClose}
          getAllNotifications={() => getAllNotifications(selectedUserType ?? undefined)}
          currentUser={currentUser}
        />
      </ReactModal>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <NotificationEdit
            setShowEdit={handleEditClose}
            getAllNotifications={() => getAllNotifications(selectedUserType ?? undefined)}
            currentUser={currentUser}
            notification={notification}
          />
        </ReactModal>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getNotifications: (userType?: number) => getNotifications(userType),
  getNotification: (id: number) => getNotification(id),
  deleteNotification: (id: number, callBack: Function) =>
    deleteNotification(id, callBack),
  getUserTypes: () => getUserTypes(),
};

function mapStateToProps(state: any) {
  return {
    notifications: state.notification.notifications,
    notification: state.notification.notification,
    currentUser: state.userDetails.userProfileData?.currentRole,
    userTypes: state.common.userTypes,
    currentRole: state.userDetails.userProfileData?.currentRole,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsIndex);
